import { render, staticRenderFns } from "./WooVariantsListDeactvieTab.vue?vue&type=template&id=47fb391a"
import script from "./WooVariantsListDeactvieTab.vue?vue&type=script&lang=js"
export * from "./WooVariantsListDeactvieTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports